// DRIFT WARNING: EmptyURIValue and UriDelimiter are mirrored in sitemap-service
// (src/sources/provider-directory/url-builder.ts), guarded by its slug-contract spec.
// Changing either value must be reflected there too or the sitemap's canonical URLs stop
// matching the directory links built here.
export const EmptyURIValue = 'all';

export const UriDelimiter = '.';

/**
 * The indexed/sitemap session-type slug that pairs with `URIPrefix.SESSION_TYPE` to
 * build the online-therapy provider-directory URL segment (e.g. `sess-online therapy`,
 * which the browser percent-encodes to `sess-online%20therapy`). Kept decoupled from the
 * `SESSION_TYPES.online.title` display label so a label change (e.g. 'Online therapy' ->
 * 'Video') cannot silently flip the emitted URL. Matches the Gatsby homepage
 * `ONLINE_THERAPY_FILTER` slug so both surfaces resolve to the same providers.
 */
export const SESSION_TYPE_ONLINE_THERAPY_SLUG = 'online therapy';

/** Session-format tag of the online option; emitted in URLs as `SESSION_TYPE_ONLINE_THERAPY_SLUG`. */
export const SESSION_TYPE_ONLINE_TAG = 'video';

/** Service-type value for psychiatry, emitted in URLs as the `mod-psychiatric` modality segment. */
export const PSYCHIATRIC_URL_SLUG = 'psychiatric';

/**
 * True when a URI segment is the city-agnostic sentinel (`EmptyURIValue`), i.e. it
 * stands in for "no specific city". Compares case-insensitively so producer and
 * consumer agree on what the sentinel means regardless of how the segment was cased
 * in the URL. Use this everywhere the sentinel is checked rather than comparing the
 * raw string, so the contract lives in one place.
 */
export const isEmptyUriValue = (value: string | null | undefined): boolean => (value ?? '').toLowerCase() === EmptyURIValue.toLowerCase();

/**
 * Route segment for the full-screen adaptive-intake takeover page
 * (`/provider-directory/get-started`). Shared so the route registration and any
 * in-app links reference one source of truth (see `.claude/rules/magic-strings.md`).
 */
export const ADAPTIVE_INTAKE_ROUTE_SEGMENT = 'get-started';

/**
 * Route segment for the provider-directory browse page (`/provider-directory/browse`).
 * Shared so the route registration and any in-app links reference one source of
 * truth (see `.claude/rules/magic-strings.md`).
 */
export const BROWSE_ROUTE_SEGMENT = 'browse';

/** `utm_medium` a care-coordination partner link carries; it marks the session as a coordinator's. */
export const ENTERPRISE_UTM_MEDIUM = 'enterprise';

/** `sessionStorage` key that remembers an enterprise session after its UTM leaves the URL. */
export const ENTERPRISE_USER_STORAGE_KEY = 'enterprise_user';
